<!-- <ng-container *ngIf="searchFilters">
  <app-slot-games-search
    #slotGamesSearch
    [page]="'footersticky'"
    [sticky]="true"
    (getSlotGames)='setSlotGames($event)'
  ></app-slot-games-search>
</ng-container> -->

<div id="footer-sticky_wrap">

  <!-- Mobile Not LoggedIn ribbon -->
  <div class="mob_footer_ribbon" *ngIf="mobFooterRibbon">
    <p>{{'footersticknavComp.feelingLucky' | translate}}
      <a (click)="navigateToRegistration()">
        {{'footersticknavComp.registerText' | translate}}
      </a>
    </p>
  </div>

  <!-- Mobile Bottom Footer Menu Sticky -->
  <div class="footer-sticky_nav" >
    <div class="footer-sticky_nav--top" [ngClass]="isUserLoggedIn ? 'loggedIn' : ''">
      <div class="footer_nav navigation">
        <!-- Main Navigation Links -->
        <ul class="main_header--menu">
          <li class="no-content">
            <a id="headerLiveCasinoLink" routerLink="{{langCode+'/casino/slots'}}" [ngClass]="activeFooterTab == 'casino' ? 'activatedLink' : ''"
              (click)="goToCasinoTabs()"><span>{{'footersticknavComp.footersticknav1' | translate}}</span></a>
          </li>
          <!-- <li class="no-content" routerLink="{{langCode+'/allgames'}}">
            <a id="headerCasinoLink" href="javascript:void(0);" (click)="goToTop()"><span>{{'footersticknavComp.Jackpots' | translate}}</span></a>
          </li> -->
          <li class="no-content">
            <a id="headerPromotionsLink" [ngClass]="activeFooterTab == 'promotions' ? 'activatedLink' : ''" routerLink="{{langCode+'/promotions'}}" (click)="goToCasinoTabs()">
              <span>{{'footersticknavComp.footersticknav3' | translate}}</span>
            </a>
          </li>
          
          <li class="no-content">
            <a id="headerPromotionsLink"  [ngClass]="activeFooterTab == 'search' ? 'activatedLink' : ''" (click)="openSearch()">
              <span>{{'footersticknavComp.footersticknav4' | translate}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-sticky_nav--bottom" [ngClass]="isUserLoggedIn ? 'footer_nav-loggedIn' : ''">
      <div class="sticky_nav--blks sticky_nav--menu-blk">
        <div id="sticky_nav--menuIcon" (click)="menuToggle()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="sticky_logo sticky_nav--blks sticky_nav--left-blk">
        <a class="main_header--logo" routerLink="{{langCode+'/'}}" (click)="goToHomePage()" *ngIf="!isUserLoggedIn">
          <img src="{{siteUrlPath}}/{{mediaPath}}/common/{{websiteName}}-m-logo.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
        </a>
        <a class="main_header--logo logoFull" routerLink="{{langCode+'/'}}" (click)="goToHomePage()" *ngIf="isUserLoggedIn">
          <img src="{{siteUrlPath}}/{{mediaPath}}/common/{{websiteName}}-m-logo-login.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
        </a>
      </div>

      <div class="sticky_nav--blks sticky_nav--center-blk">
        <a href="{{langCode+'/login'}}" *ngIf="!isUserLoggedIn && isCountryAllowed === 2" class="sticky_nav--btn sticky_nav--btn_login sticky_nav--link_btn"
          (click)="navigateTo($event, 'login')">{{'footersticknavComp.footersticknav11' | translate}}</a>
          <a *ngIf="!isUserLoggedIn && isCountryAllowed===1" class="sticky_nav--btn sticky_nav--btn_login sticky_nav--link_btn"
                routerLink="{{langCode+'/login'}}" (click)="linkLoginPnp()"><span>{{'headerComp.logInBtn' | translate}}</span></a>
      </div>
      
      <div class="sticky_nav--blks sticky_nav--right-blk">
        
       
        <a *ngIf="!isUserLoggedIn && isCountryAllowed===1" class="sticky_nav--btn sticky_nav--btn_register sticky_nav--link_btn"
        (click)="doDeposit($event)"
          href="{{dynamicHrefPath+'?showDeposit=true'}}">
          {{'headerComp.playinstantly' | translate}}
        </a>

        <a href="{{langCode+'/register'}}" *ngIf="!isUserLoggedIn && isCountryAllowed===2" class="sticky_nav--btn sticky_nav--btn_register sticky_nav--link_btn"
          (click)="navigateTo($event, 'registration')">
          {{'footersticknavComp.footersticknav22' | translate}}
        </a>

        <a *ngIf="isUserLoggedIn" class="sticky_nav--btn sticky_nav--btn_deposit sticky_nav--cta_btn"
          (click)="doDeposit($event)" href="{{dynamicHrefPath+'?showDeposit=true'}}">{{ userTotalBalance | currencyPipe}}</a>
      </div>
    </div>
  </div>
</div>